$(function(){
$(".historyArea .hide").hide();
$(".acc_btn").on('click', function() {
$(this).fadeOut();
$(".historyArea .hide").slideDown();
});


$(".sideArea li a").on("click",  function() {
    if( $("[href^='#']") ){
    $(".sideArea li").removeClass('current');
    $(this).parent().addClass('current');
    const speed = 600;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? "html" : href);
    let position = target.offset().top;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
     }
    });
});

$('.faqArea dl dt .cross').on("click",  function() {
    $(this).parent('dt').next('dd').stop().slideToggle();
});

$(function(){
    $(".study_list dt .tglbtn").addClass('down');
    $(".study_list dt .tglbtn").on("click",function(){
        $(this).parent('dt').next('dd').stop().slideToggle(500)
        if($(this).hasClass("down")){
            $(this).removeClass("down");
            $(this).addClass("up");
        }else{
            $(this).removeClass("up");
            $(this).addClass("down");
        }
    });


});